import { ArrowRight } from "lucide-react";

export const MobileCta = () => (
  <div
    data-testid="mobile-sticky-bar"
    className="fixed bottom-0 inset-x-0 z-40 lg:hidden border-t border-black/10 bg-white/90 backdrop-blur-xl px-4 py-3"
  >
    <a
      href="#book"
      data-testid="mobile-sticky-cta"
      className="btn-shine flex items-center justify-center gap-2 rounded-full bg-champagne px-6 py-3.5 text-sm font-medium tracking-wide text-white"
    >
      Book My Audit
      <ArrowRight size={15} />
    </a>
  </div>
);
